module.exports = __webpack_public_path__ + "img/tubiao-26.a216f348.png";